// extracted by mini-css-extract-plugin
module.exports = {"container":"U892HIOs9S-coLY23Mr5V"};